import type { HistoryItem } from './changeLogTypes';

export const isPrimitive = (v: unknown) =>
  v === null || v === undefined || ['string', 'number', 'boolean', 'bigint'].includes(typeof v);

/** A plain value as people read it: On/Off for switches, "-" for nothing. */
export function formatPrimitive(v: unknown): string {
  if (v === null || v === undefined || v === '') return '-';
  if (typeof v === 'boolean') return v ? 'On' : 'Off';
  return String(v);
}

/** Who made a change: their name, else their email, else the system itself. */
export const actorLabel = (item: HistoryItem) => item.actor?.name || item.actor?.email || 'System';
